import { styled } from "@mui/material/styles";
import List, { ListProps } from "@mui/material/List";
import ListItem, { ListItemProps } from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import { Box, BoxProps, ListItemButtonProps } from "@mui/material";

export const ListComponent = styled((props: ListProps) => <List {...props} />)(({ theme }) => ({
    width: "100px",
    zIndex: "1000",
    height: "100vh",
    backgroundColor: "#F7F7FF",
    position: "fixed",
    "@media (min-width: 300px) and (max-width: 600px)": {
        position: "absolute",
        bottom: 0,
        display: "flex",
        height: "auto",
        width: "100vw",
        marginTop: "0px",
    },
}));
export const ListItemGoOut = styled((props: ListItemProps) => <ListItem {...props} />)(({ theme }) => ({
    position: "absolute",
    bottom: 80,
    flexDirection: "column",
    "@media (min-width: 300px) and (max-width: 600px)": {
        position: "relative",
        bottom: 0,
        hr: {
            display: "none",
        },
    },
}));

export const ListItemButtonComponent = styled((props: ListItemButtonProps & { isselected: string }) => <ListItemButton {...props} />)(
    ({ theme, isselected }) => ({
        width: "100%",
        justifyContent: "center",
        backgroundColor: isselected === "true" ? "#E6E7F7" : "transparent",
        p: {
            color: isselected === "true" ? "#2B25B8" : "#9192AD",
        },
    })
);

export const BoxsMenu = styled((props: BoxProps) => <Box {...props} />)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
}));
